var ServerAction = (function () {
    function ServerAction(receiverId, name, args) {
        this.ReceiverId = receiverId;
        this.Name = name;
        args.MapperId = args.MapperId || name;
        this.Arguments = Array.isArray(args) ? args : [args];
    }
    return ServerAction;
}());
export { ServerAction };
